var inherit = require("../../general.js").inherit;
var SortedMap = require("../../collections/sortedMap.js");
var HashMap = require("../../collections/hashMap.js");
var ObservableMap = require("./../observableMap.js");
var TreeEvent = require('./treeEvent.js');

var ObservableTreeMap = function(treeNode, name, owner, validator){
    ObservableMap.call(this, validator);
    this._treeNode = treeNode;
    this._name = name;
    this._owner = owner || false;
    this.handlers.bubble = null;
};
inherit(ObservableTreeMap, ObservableMap);
ObservableTreeMap.prototype.getName = function(){ return this._name; };
ObservableTreeMap.prototype.getTreeNode = function(){ return this._treeNode; };
ObservableTreeMap.prototype.isOwner = function(){ return this._owner; };

ObservableTreeMap.prototype.onBubble = function(key, handler, priority){
    console.assert(key != null && handler && typeof handler == "function", "Scheduling handler expects a valid key + handler function");
    if(!this.handlers.bubble) this.handlers.bubble = new SortedMap();
    this.handlers.bubble.put(key, handler, priority || 0);
};

ObservableTreeMap.prototype.replaceWithoutTriggers = function(newVal, oldVal){
    var keys = this.getKeysForValue(oldVal);
    for(var i = 0; i < keys.length; i++){
        this.remove(keys[i], true);
        this.put(keys[i], newVal, true);
    }
}

ObservableTreeMap.prototype.put = function(key, val, noObservations){
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    var old = this.get(key);
    if (!(this.contains(key) && old === val)) {
        var validated = !this.validator || this.validator(key, val, old);
        if (validated) {
            HashMap.prototype.put.call(this, key, val);
            
            if (this._owner){
                if (key && key.isObservableTreeNode) key.referrers.add([this, key]);
                if (old && old.isObservableTreeNode) old._removeTreeNode();
                if (val && val.isObservableTreeNode) val._addTreeNodeTo([this, key]);
            } else {
                if (key && key.isObservableTreeNode) key.referrers.add([this, key]);
                if (old && old.isObservableTreeNode) old.referrers.remove([this, key]);
                if (val && val.isObservableTreeNode) val.referrers.add([this, key]);
            }

            if(!noObservations){
                var event = new TreeEvent("put", this, key, val, old);
                if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

                this.handlers.put && this.handlers.put.forEach(function (k, handler) {
                    handler.call(self, key, val, old);
                });

                event.trigger();
            }
        } else {
            if(!noObservations){
                this.handlers.putFail && this.handlers.putFail.forEach(function (k, handler) {
                    handler.call(self, key, val, old);
                });
            }
        }
        return validated;
    } else return true;
};

ObservableTreeMap.prototype.remove = function(key, noObservations) {
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    if (this.contains(key)) {
        var old = HashMap.prototype.remove.call(this, key);
        
        if (this._owner){
            if (key && key.isObservableTreeNode) key.referrers.remove([this, key]);
            if (old && old.isObservableTreeNode) old._removeTreeNode();
        } else {
            if (key && key.isObservableTreeNode) key.referrers.remove([this, key]);
            if (old && old.isObservableTreeNode) old.referrers.remove([this, key]);
        }

        if(!noObservations){
            var event = new TreeEvent("remove", this, key, undefined, old);
            if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

            this.handlers.remove && this.handlers.remove.forEach(function(k, handler){
                handler.call(self, key, old);
            });

            event.trigger();
        }

        return old;
    }
};

module.exports = ObservableTreeMap;